import { ChangeDetectionStrategy, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { AccessControlRoleDialogComponent } from 'src/app/global/components/dialogs/access-control-role-dialog/access-control-role-dialog.component';
import { AccessControlTableComponent } from 'src/app/global/components/access-control/access-control-table/access-control-table.component';

@Component({
    selector: 'app-collections-list',
    templateUrl: './access-control-list.component.html',
    styleUrls: ['./access-control-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessControlListComponent implements OnDestroy {
    destroy$ = new Subject();

    @ViewChild(AccessControlTableComponent) tableComponent: AccessControlTableComponent;

    constructor(private dialog: MatDialog) {}

    openEditAreasDialog() {
        this.dialog.open(AccessControlRoleDialogComponent, { width: '600px' });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
